import React, { useContext } from 'react';

import { CustomTextContext } from 'context/CustomTextContext';
import overrideStyle from 'lib/overrideStyle';

const Wrapper = overrideStyle('div')`
    padding: 0 35px;
    padding-top: 5px;
`;

export default function OfficeHourDisplay() {
  const { officeHourMessage } = useContext(CustomTextContext);
  return <Wrapper dangerouslySetInnerHTML={{ __html: officeHourMessage }} />;
}
